import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { Colors } from '../../utils/theme';

const InnerLoader: React.FunctionComponent = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: Colors.main,
        marginTop: '14%'
      }}
    >
      <CircularProgress color="inherit" />
    </Box>
  );
};

export default InnerLoader;
